import {
  Button,
  Icon,
  InformationCard,
  prependZeroToSingleDigitNumber,
  SafeHtmlContent
} from '@yes.technology/react-toolkit'
import { isNumber } from 'lodash'
import { useIsOpen } from 'shared/hooks'
import { DataChartValue } from './ChartWrapper'
import {
  Card,
  Content,
  Count,
  CountContainer,
  Header,
  Title,
  Unit
} from './styles'

interface ItemProps {
  title: string
  count: DataChartValue
  image?: string
  backgroundColor?: string
  textForInformationCard?: string
  measurementUnit?: string
}

const CardItem = ({
  backgroundColor,
  title,
  image,
  count,
  textForInformationCard,
  measurementUnit
}: ItemProps) => {
  const { isOpen, open, close } = useIsOpen(false)
  return (
    <>
      <Card {...{ backgroundColor, image }} aria-label={`Card ${title}`}>
        <Header>
          <Title>{title}</Title>
          <Button
            variant='secondary'
            heightClass='semiSmall'
            disabled={!textForInformationCard}
            onClick={open}
          >
            <Icon iconName='Information' icSize={'semiSmall'} />
          </Button>
        </Header>
        <Content>
          <CountContainer>
            {isNumber(count) && (
              <Count>{prependZeroToSingleDigitNumber(count)}</Count>
            )}
            {measurementUnit && <Unit>{measurementUnit}</Unit>}
          </CountContainer>
        </Content>
      </Card>
      {textForInformationCard && (
        <InformationCard {...{ title, isOpen, close }}>
          <SafeHtmlContent html={textForInformationCard} />
        </InformationCard>
      )}
    </>
  )
}

export default CardItem
